import encuestas from "../apis/encuestas";
import gabinete from "../apis/gabinete";
import api_g from "../apis/api_g";

import {
  OBTIENE_ENCUESTAS,
  SET_FORMULARIO,
  GET_INICIATIVAS,
  SET_PREGUNTA_ACTIVA,
  GET_USUARIO,
  SET_ANSWER,
  SET_ANSWERNEW,
  GET_TICKET,
  SET_RESPUESTA,
  SET_PREGUNTA_CUATERNA,
  SET_PREGUNTA_LOCAL,
  GET_REPORTE,
} from "./types";

import { GET_ENTREGA_ENTRADA, SET_ENTREGA_ENTRADA } from "./types";

export const getEncuestas2 = (filtros) => {
  return {
    type: OBTIENE_ENCUESTAS,
    payload: [{ id_encuesta: 1 }],
  };
};

export const getEncuestas = (parametros) => async (dispatch) => {
  const response = await encuestas.post("/registration", parametros);
  dispatch({ type: OBTIENE_ENCUESTAS, payload: response.data });
};

export const setFormulario = (parametros) => {
  return { type: SET_FORMULARIO, payload: parametros };
};

export const getIniciativas = (parametros) => async (dispatch) => {
  const response = await encuestas.post("/registration", parametros);
  dispatch({ type: GET_INICIATIVAS, payload: response.data });
};

export const getEntregaEntrada = (parametros) => async (dispatch) => {
  const response = await gabinete.post("/registration", parametros);
  dispatch({ type: GET_ENTREGA_ENTRADA, payload: response.data });
};

export const setEntregaEntrada = (parametros) => async (dispatch) => {
  const response = await gabinete.post("/registration", parametros);
  dispatch({ type: SET_ENTREGA_ENTRADA, payload: response.data });
};

export const setPreguntaActiva = (parametros) => {
  return { type: SET_PREGUNTA_ACTIVA, payload: parametros };
};

export const getUsuario = (parametros) => async (dispatch) => {
  const response = await encuestas.post("/registration", parametros);
  dispatch({ type: GET_USUARIO, payload: response.data });
};

export const setAnswer = (parametros) => async (dispatch) => {
  const response = await encuestas.post("/registration", parametros);
  dispatch({ type: SET_ANSWER, payload: response.data });
};

export const setAnswerNew = (parametros) => async (dispatch) => {
  const response = await encuestas.post("/registration", parametros);
  dispatch({ type: SET_ANSWERNEW, payload: response.data });
};

//===========================================================+
// 2024

export const getTicket = (parametros) => async (dispatch) => {
  try {
    const response = await api_g.post("/ticket", parametros);

    dispatch({ type: GET_TICKET, payload: response.data });

    // IMPORTANTE: Retornar los datos permite que el componente Login espere (await)
    return response.data;
  } catch (error) {
    console.error("Error obteniendo ticket:", error);
    // Lanzamos el error para que el bloque 'catch' del componente Login lo detecte
    // y pueda apagar el spinner (en el finally)
    throw error;
  }
};

export const setRespuesta = (parametros) => async (dispatch) => {
  try {
    const response = await api_g.post("/respuesta", parametros);
    dispatch({ type: SET_RESPUESTA, payload: response.data });
    return response.data;
  } catch (error) {
    console.error("Error guardando respuesta:", error);
    throw error;
  }
};

export const setPreguntaCuaterna = (parametros) => {
  return { type: SET_PREGUNTA_CUATERNA, payload: parametros };
};

export const setPreguntaLocal = (parametros) => {
  return { type: SET_PREGUNTA_LOCAL, payload: parametros };
};

export const getReporte = (parametros) => async (dispatch) => {
  try {
    const response = await api_g.post("/reporte", parametros);
    dispatch({ type: GET_REPORTE, payload: response.data });
    return response.data;
  } catch (error) {
    console.error("Error obteniendo reporte:", error);
    throw error;
  }
};

// Análisis detallado pregunta a pregunta de un evaluado (dbo.GetAnalisisEvaluado).
// No se guarda en redux: el componente usa el valor retornado en estado local.
export const getAnalisis = (parametros) => async (dispatch) => {
  try {
    const response = await api_g.post("/analisis", parametros);
    return response.data; // { status, data: [...], message }
  } catch (error) {
    console.error("Error obteniendo analisis:", error);
    throw error;
  }
};
